import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface StoryBoardGenerationType {
  progress: number;
  shotStates: {
    [key: string]: {
      state: string;
    };
  };
  shotsCompleted: number;
}

const initialState: StoryBoardGenerationType = {
  progress: 0,
  shotStates: {},
  shotsCompleted: 0,
};

const storyBoardGenerationSlice = createSlice({
  name: "storyBoardGeneration",
  initialState,
  reducers: {
    setStoryBoardGeneration: (state, action: PayloadAction<any>) => {
      state.progress = action.payload.progress;
      state.shotStates = action.payload.shotStates;
      state.shotsCompleted = action.payload.shotsCompleted;
    },
  },
});

export const { setStoryBoardGeneration } = storyBoardGenerationSlice.actions;

export default storyBoardGenerationSlice.reducer;
